<template>
  <div>
    <b-form-checkbox :style="{margin: noMargin ? 0 : null}" v-model="localValue" @input="onInput" :class="{ 'invalid-state': state === false }" @change="$emit('change', $event)">
      <slot></slot>
    </b-form-checkbox>
    <b-form-invalid-feedback :state="state">
      {{ errorMsg }}
    </b-form-invalid-feedback>
  </div>
</template>

<script>
import { BFormCheckbox, BFormInvalidFeedback } from 'bootstrap-vue'

const messages = {
  es: {
    'base-checkbox': {
      'error-msg': 'Debe marcar la casilla'
    }
  },
  en: {
    'base-checkbox': {
      'error-msg': 'You must check the box'
    }
  },
	pt: {
		'base-checkbox': {
			'error-msg': 'Você deve marcar a caixa'
		}
	}
}

export default {
  components: {
    BFormCheckbox,
    BFormInvalidFeedback
  },
  i18n: {
    messages
  },
  props: {
    value: [String, Object, Boolean],
    onInput: {
      type: Function,
      required: false,
      default: () => {}
    },
    state: {
      type: Boolean,
      required: false,
      default: null
    },
    errorMsg: {
      type: String,
      required: false,
      default () {
        return this.$t('base-checkbox.error-msg')
      }
    },
    noMargin: Boolean
  },
  data () {
    return {
      localValue: null
    }
  },
  created () {
    this.localValue = this.value
    this.$watch('localValue', value => {
      this.$emit('input', value)
    })
    this.$watch('value', value => {
      this.localValue = value
    })
  }
}
</script>

<style lang="scss">
  .invalid-state .custom-control-label::before {
    border-color: $red;
  }
</style>


// WEBPACK FOOTER //
// src/components/base/forms/BaseCheckbox.vue